<template lang="pug">
  help-dialog(:show="visible" @close="visible = false")
    h5 {{$t('management_page.system_policy')}}
    p {{$t('management_page.system_policy_applies_to_all')}}
    ul
      li
        .tit 1. {{$t('management_page.user_remote_approval_process')}}
        .txt-1 {{$t('management_page.approval_process_enabled')}}
        .txt-2 {{$t('management_page.approval_process_exception_unchanged')}}
        .txt-1 {{$t('management_page.approval_process_disabled')}}
        .txt-2 {{$t('management_page.approval_process_disabled_effect')}}
      li
        .tit 2. {{$t('blocking-settings')}}
        .txt-1 {{$t('management_page.ip_management_enabled')}}
        .txt-1 {{$t('management_page.ip_management_disabled')}}
</template>

<script>
import HelpDialog from "@/components/mixins/dialog/help.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HelpDialog,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style lang="scss" scoped src="./dialog.scss"></style>
